var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReorder(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 30,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "reorder_svg__svg-1316784581-a",
    d: "M15.9 3.455a7.506 7.506 0 011.394 3.787h4.451a.98.98 0 01.992.968v14.516c0 .89-1.127 1.308-1.732.643l-1.242-1.364-1.242 1.364a1.008 1.008 0 01-1.486-.004l-1.224-1.36-1.26 1.368a1.007 1.007 0 01-1.48-.007l-1.231-1.36-1.252 1.365c-.606.662-1.73.243-1.73-.645v-7.25c-2.252-.175-4.409-1.293-5.805-3.24a.954.954 0 01.243-1.348 1.005 1.005 0 011.38.238 5.876 5.876 0 004.182 2.407V8.21a.98.98 0 01.991-.968h5.454a5.604 5.604 0 00-1.028-2.677c-1.856-2.587-5.509-3.216-8.16-1.405-.408.28-.773.603-1.09.964l3.496 1.97-6.434 1.563L.255 1.435l3.031 1.708a7.76 7.76 0 011.692-1.568C8.526-.85 13.415-.008 15.9 3.455zm4.854 5.722h-9.913v11.015l.264-.289a1.007 1.007 0 011.482.005l1.234 1.363 1.262-1.37a1.008 1.008 0 011.482.009l1.22 1.354 1.237-1.359a1.008 1.008 0 011.482 0l.25.275V9.177zm-1.959 5.807a.968.968 0 110 1.935H12.8a.967.967 0 110-1.935h5.995zm0-3.871a.968.968 0 110 1.935H12.8a.967.967 0 110-1.935h5.995z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3.94 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "reorder_svg__svg-1316784581-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reorder_svg__svg-1316784581-a"
  })), /*#__PURE__*/React.createElement("use", {
    className: "svg-fill-75",
    fillRule: "nonzero",
    xlinkHref: "#reorder_svg__svg-1316784581-a"
  }), /*#__PURE__*/React.createElement("g", {
    className: "svg-fill-75",
    mask: "url(#reorder_svg__svg-1316784581-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-3h30.884v30H-3z"
  })))));
}

export default SvgReorder;